import whiteStatusbar from 'url:../../../assets/images/white-statusbar.webp';
import greatJobVideo from 'url:../../../assets/videos/great-job-video.mp4';

export const greatJobVideoAssets = {
  whiteStatusbar,
  greatJobVideo,
} as const;

export const greatJobVideoAssetList = Object.values(greatJobVideoAssets);
